import React from "react";
import user from "../assets/UsermngmtAssets/total-users-icon.svg";
import role from "../assets/UsermngmtAssets/active-roles-icon.svg";
import resource from "../assets/UsermngmtAssets/resources-icon.svg";
import scope from "../assets/UsermngmtAssets/scopes-icon.svg";
import permission from "../assets/UsermngmtAssets/permissions-icon.svg";
import admin from "../assets/UsermngmtAssets/admin-icon.svg";
import team from "../assets/UsermngmtAssets/team-icon.svg";
import self from "../assets/UsermngmtAssets/self-icon.svg";
import edit from "../assets/UsermngmtAssets/edit_icon.svg";
import remove from "../assets/UsermngmtAssets/delete-icon.png";
import eyes from "../assets/UsermngmtAssets/eyes-icon.svg";
import tick from "../assets/UsermngmtAssets/tick-icon.svg";
import cancel from "../assets/UsermngmtAssets/cancel-icon.svg";
import FlashOnOutlined from "@mui/icons-material/FlashOnOutlined";
const assets = {user, role, resource, scope, permission, admin, team, self, edit, delete: remove, eyes, tick, cancel};
export default function UserManagementIcon({name, className = ""}) {
  return name === "action" ? <span className={`user-management-icon user-management-action-icon ${className}`}><FlashOnOutlined fontSize="small" /></span> : <img className={`user-management-icon ${className}`} src={assets[name]} alt="" aria-hidden="true" />;
}
